import React, { Component } from 'react';
import { connect } from '~/redux/connect';
import { getResetPasswordResult } from '~/stateGetter';
import { presentAuthError } from '~/statePresenter';
import { ResetPasswordForm } from '~/ui/LoginForm';
import { AuthLayout } from './AuthLayout';
import { Link } from "~/ui/Link/Link";

export class ResetPasswordPage extends Component {
    get hasError() {
        const error = this.props.error;
        return !(!error || !error.length)
    }
    
    get title() {
        let { trans } = this.props;
        if (this.hasError) return trans('resetPasswordPage.errorTitle')
        return trans('resetPasswordPage.welcomeTitle')
    }

    get message() {
        let { trans, error } = this.props;
        if (!error || !error.length) return trans('resetPasswordPage.welcomeMessage');
        return error;
    }

    get labels() {
        return {
            submitButton: this.props.trans('resetPasswordPage.submitButton'),
            password: this.props.trans('password'),
            confirmPassword: this.props.trans('resetPasswordPage.confirmPassword'),
        }
    }

    renderFooter = (color) => {
        return <Link href="/" color={color} shouldPush>{this.props.trans("resetPasswordPage.login")}</Link>
    }


    renderForm() {
        return <ResetPasswordForm labels={this.labels} />
    }

    render() {
        return (
            <AuthLayout message={this.message} title={this.title} renderFooter={this.renderFooter}>
                {this.renderForm()}
            </AuthLayout>
        );
    }
}

const RXResetPasswordPage = connect(
    (state) => {
        return {
            token: state.router.query.resetToken,
            error: presentAuthError(getResetPasswordResult(state, 'updatePassword') ?? {} )
        };
    },
)(ResetPasswordPage);

export default RXResetPasswordPage;
